import React, { useEffect, useState } from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import axios from "axios";
import FleetListDocument from "./FleetListDocument";
import { IoArrowBack } from "react-icons/io5";

const FleetListPrint = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [fleetListPrintData, setFleetListPrintData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (location.state) {
      setFleetListPrintData(location.state.filteredData);
      setLoading(false);
    }
  }, [location]);

  console.log("fleetListPrintData:", fleetListPrintData);

  const onBack = () => {
    navigate("/admin/fleetList");
  };

  return (
    <div className="mx-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-normal my-4">Fleet List Print</h2>

        <button
          onClick={onBack}
          className="flex items-center gap-2 bg-gray-700 hover:bg-gray-800 
                            text-white px-4 py-2 rounded-lg 
                            transition-all duration-200 
                            shadow-sm hover:shadow-md"
        >
          <IoArrowBack className="text-lg" />
          Back
        </button>
      </div>

      <div className="flex flex-col items-center h-screen">
        {loading ? (
          <div className="text-center text-gray-500 mt-10">
            Loading Payment Data...
          </div>
        ) : !fleetListPrintData || fleetListPrintData.length === 0 ? (
          <div className="text-center text-gray-500 mt-10">
            No Fleet List Available!
          </div>
        ) : (
          <>
            <div className="w-full h-screen border border-gray-300 mb-4">
              <PDFViewer width="100%" height="100%">
                <FleetListDocument fleetListPrintData={fleetListPrintData} />
              </PDFViewer>
            </div>

            <div className="mt-4 mb-6">
              <PDFDownloadLink
                document={
                  <FleetListDocument fleetListPrintData={fleetListPrintData} />
                }
                fileName={`Fleet_List || "print"}.pdf`}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                {({ loading }) =>
                  loading
                    ? "Preparing PDF..."
                    : "Download Fleet List"
                }
              </PDFDownloadLink>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default FleetListPrint;
